<div [ngClass]="backgroundClass()" class="d-flex position-relative p-2 top-shadow align-items-center">
  <div class="container-fluid px-2">
    <div class="row align-items-center">
      <div class="col-12 col-sm align-items-center">
        <!-- Projected Logo and Headings -->
        <div class="row align-items-center">
          <div class="col-auto d-flex align-items-center">
            <!-- Projected logo content goes here -->
            <img [src]="src" alt="logo" class="logo" logo [style.height]="height || 'auto'"/>
            <!-- <ng-content select="[logo]"></ng-content> -->
          </div>
          <div class="col">
            <!-- Display the translated heading and subheading -->
            <h4 [ngClass]="theme === 'dark' ? 'text-white': 'text-black'" class="heading text-theme-color mt-0 mb-0">{{ heading }}</h4>
            <h6 [ngClass]="theme === 'dark' ? 'text-white': 'text-black'" class="subheading mt-0 mb-0 text-muted">{{ subHeading }}</h6>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-auto">
        <!-- Language Selector Component -->
        <div class="text-right">
          <city-tax-language-selector [theme]="theme"></city-tax-language-selector>
        </div>
      </div>
    </div>
  </div>
</div>
